import { Component, OnInit } from '@angular/core';
import {NzModalModule, NzModalService} from 'ng-zorro-antd/modal';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ContactService } from '../services/contact.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { TemplateService } from '../services/template.service';
import { ProgressService } from '../services/progress.service';
import {NzIconModule} from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {GermanPhoneNormalizerService} from '../services/german.phone.normalizer.service';
import { firstValueFrom } from 'rxjs';
import { ContactUpsertModalService } from './contact-upsert-modal.service';
import {PropertyInlineContactAddService} from '../property-list/property-inline-contact-add.service';
import { shouldSuppressGenericError } from '../utils/http-error.utils';
import { getServiceTypes, normalizeServiceContact } from '../utils/service-type.utils';
import { matchesPhoneSearch, matchesTextSearch } from '../utils/search-normalization.utils';

const serviceTypeTranslationKeys: { [key: string]: string } = {
  'Heating': 'HEATING',
  'Sanitary': 'SANITARY',
  'Smoke Detector': 'SMOKE_DETECTOR',
  'Elevator': 'ELEVATOR',
  'Winter Service': 'WINTER_SERVICE',
  'Electrical': 'ELECTRICAL',
  'Garage Door': 'GARAGE_DOOR',
  'Pipe Blockage': 'PIPE_BLOCKAGE',
  'Pipe Burst & Water Damage': 'PIPE_BURST_WATER_DAMAGE',
  'Cable Television': 'CABLE_TELEVISION',
  'Stairwell Cleaning': 'STAIRWELL_CLEANING',
  'Locksmith Service': 'LOCKSMITH_SERVICE',
  'Chimney Sweep': 'CHIMNEY_SWEEP',
  'Meter Reading Service': 'METER_READING_SERVICE',
  'Bulk Waste Collection': 'BULK_WASTE_COLLECTION',
  'Gas Supply/Emergency Service': 'GAS_SUPPLY_EMERGENCY_SERVICE',
  'Power Supply/Emergency Service': 'POWER_SUPPLY_EMERGENCY_SERVICE',
  'Water Supply': 'WATER_SUPPLY',
  'Police': 'POLICE',
  'Garden Maintenance': 'GARDEN_MAINTENANCE',
  'Pest Control': 'PEST_CONTROL',
  'Energy Supply': 'ENERGY_SUPPLY',
  'Waste Disposal': 'WASTE_DISPOSAL',
  'Building Insurance': 'BUILDING_INSURANCE',
  'Fiber / Internet': 'FIBER_INTERNET',
  'Gas Emergency/Gas Odor': 'GAS_EMERGENCY_GAS_ODOR',
  'Recyclable Waste Disposal': 'RECYCLABLE_WASTE_DISPOSAL',
  'Heating Oil Supply': 'HEATING_OIL_SUPPLY',
  'District Heating Supplier': 'DISTRICT_HEATING_SUPPLIER',
  'Lifting Systems and Pumps': 'LIFTING_SYSTEMS_AND_PUMPS',
  'Electric Storage Heater': 'ELECTRIC_STORAGE_HEATER',
  'Locking System Maintenance': 'LOCKING_SYSTEM_MAINTENANCE',
  'Green Roof Maintenance': 'GREEN_ROOF_MAINTENANCE',
  'Rental Mat Service': 'RENTAL_MAT_SERVICE',
  'Local Heating Supplier': 'LOCAL_HEATING_SUPPLIER',
  'Street and Sidewalk Cleaning': 'STREET_AND_SIDEWALK_CLEANING',
  'Double Parker': 'DOUBLE_PARKER',
  'Gate/Gate Systems': 'GATE_GATE_SYSTEMS',
  'Sewer/Blockage': 'SEWER_BLOCKAGE',
  'Solar System/PVA': 'SOLAR_SYSTEM_PVA',
  'Ventilation': 'VENTILATION',
  'Apartment Transfer Station (DHW/Heating)': 'APARTMENT_TRANSFER_STATION_DHW_HEATING',
  'Smoke and Heat Extraction System': 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM',
  'Fire Extinguisher': 'FIRE_EXTINGUISHER',
  'Fire Doors': 'FIRE_DOORS',
  'Fire Alarm System': 'FIRE_ALARM_SYSTEM',
  'Heating Cost Allocator': 'HEATING_COST_ALLOCATOR',
  'WE Meter': 'WE_METER',
  'Coating (UG)': 'COATING_UG',
  'Windows': 'WINDOWS',
  'Roller Shutter/Raffstore': 'ROLLER_SHUTTER_RAFFSTORE',
  'Doors': 'DOORS',
  'Roofer': 'ROOFER',
  'Property Developer': 'PROPERTY_DEVELOPER',
  'Green Pruning': 'GREEN_PRUNING',
};

@Component({
  selector: 'app-contact-list',
  standalone: true,
  imports: [
    CommonModule,
    NzTableModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzTimePickerModule,
    NzModalModule,
    FormsModule,
    NzPaginationModule,
    TranslateModule,
    ReactiveFormsModule,
    NzIconModule,
    NzToolTipModule
  ],
  providers: [
    NzModalService,
    NzMessageService,
    ContactUpsertModalService,
    PropertyInlineContactAddService
  ],
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.less']
})
export class ContactListComponent implements OnInit {

  allEmployees: any[] = [];
  allCaretakers: any[] = [];
  allServices: any[] = [];

  employees: any[] = [];
  caretakers: any[] = [];
  services: any[] = [];

  employeesPagination = {
    pageIndex: 1,
    pageSize: 5,
    total: 0
  };

  caretakersPagination = {
    pageIndex: 1,
    pageSize: 5,
    total: 0
  };

  servicesPagination = {
    pageIndex: 1,
    pageSize: 5,
    total: 0
  };

  employeesSort: { key: string; value: string | null } = { key: '', value: null };
  caretakersSort: { key: string; value: string | null } = { key: '', value: null };
  servicesSort: { key: string; value: string | null } = { key: '', value: null };

  // Loading Indicators
  isLoadingEmployees = false;
  isLoadingCaretakers = false;
  isLoadingServices = false;

  headers: string[] = [];
  serviceOptions: Array<{ label: string; value: string }> = [];

  // Table visibility flags
  showEmailFieldTable = false;
  showPhoneFieldTable = false;

  roleOptions: { label: string; value: string }[] = [];

  employeeSearchTerm = '';
  caretakerSearchTerm = '';
  serviceSearchTerm = '';

  originalEmployees: any[] = [];
  originalCaretakers: any[] = [];
  originalServices: any[] = [];

  deletingServiceId: string | null = null;
  deletingEmployeeId: string | null = null;
  deletingCaretakerId: string | null = null;

  constructor(
    private contactService: ContactService,
    private translate: TranslateService,
    private message: NzMessageService,
    private templateService: TemplateService,
    private progressService: ProgressService,
    private dePhone: GermanPhoneNormalizerService,
    private contactUpsertModal: ContactUpsertModalService) { }

  ngOnInit(): void {
    this.loadHeaders();
    this.loadEmployees();
    this.loadCaretakers();
    this.loadServices();
  }

  loadHeaders() {
    this.templateService.getSavedHeaders().subscribe(
      (savedHeaders) => {
        // Initialize headers array
        this.headers = [];

        // Extract headers from savedHeaders
        if (savedHeaders.propertyManagerHeaders) {
          this.headers.push(...savedHeaders.propertyManagerHeaders);
        }
        if (savedHeaders.technicalAssetsManagerHeaders) {
          this.headers.push(...savedHeaders.technicalAssetsManagerHeaders);
        }
        if (savedHeaders.sevManagerHeaders) {
          this.headers.push(...savedHeaders.sevManagerHeaders);
        }
        if (savedHeaders.accountantHeaders) {
          this.headers.push(...savedHeaders.accountantHeaders);
        }
        if (savedHeaders.caretakerHeaders) {
          this.headers.push(...savedHeaders.caretakerHeaders);
        }
        if (savedHeaders.technicalServiceHeaders) {
          this.headers.push(...savedHeaders.technicalServiceHeaders);
        }

        // Adjust roleOptions based on available headers
        this.translate
          .get(['ROLES.PROPERTY_MANAGER', 'ROLES.TECHNICAL_ASSETS_MANAGER', 'ROLES.CONDOMINIUM_MANAGER', 'ROLES.ACCOUNTANT'])
          .subscribe((translations) => {
            this.roleOptions = [
              {
                label: translations['ROLES.PROPERTY_MANAGER'],
                value: 'Property Manager',
              },
              {
                label: translations['ROLES.TECHNICAL_ASSETS_MANAGER'],
                value: 'Technical Assets Manager',
              },
              {
                label: translations['ROLES.CONDOMINIUM_MANAGER'],
                value: 'Condominium Manager',
              },
              {
                label: translations['ROLES.ACCOUNTANT'],
                value: 'Accountant',
              },
            ].filter((option) => {
              const roleNameHeader = `${option.value.toUpperCase().replace(/ /g, '_')}_NAME`;
              return this.headers.includes(roleNameHeader);
            });
          });

        // Full list of possible service types with header keys
        const knownServices = [
          { type: 'Waste Disposal', headerKey: 'WASTE_DISPOSAL' },                         // Abfallentsorgung
          { type: 'Meter Reading Service', headerKey: 'METER_READING_SERVICE' },           // Ablesedienst
          { type: 'Elevator', headerKey: 'ELEVATOR' },                                      // Aufzug
          { type: 'Property Developer', headerKey: 'PROPERTY_DEVELOPER' },                   // Bauträger
          { type: 'Coating (UG)', headerKey: 'COATING_UG' },                                // Beschichtung (TG)
          { type: 'Fire Alarm System', headerKey: 'FIRE_ALARM_SYSTEM' },                    // Brandmeldeanlage
          { type: 'Fire Doors', headerKey: 'FIRE_DOORS' },                                  // Brandschutztüren
          { type: 'Double Parker', headerKey: 'DOUBLE_PARKER' },                            // Doppelparker
          { type: 'Energy Supply', headerKey: 'ENERGY_SUPPLY' },                            // Energieversorgung
          { type: 'Electrical', headerKey: 'ELECTRICAL' },                                  // Elektrik
          { type: 'District Heating Supplier', headerKey: 'DISTRICT_HEATING_SUPPLIER' },    // Fernwärmeversorger
          { type: 'Windows', headerKey: 'WINDOWS' },                                         // Fenster
          { type: 'Fire Extinguisher', headerKey: 'FIRE_EXTINGUISHER' },                    // Feuerlöscher
          { type: 'Garage Door', headerKey: 'GARAGE_DOOR' },                                // Garagentor
          { type: 'Garden Maintenance', headerKey: 'GARDEN_MAINTENANCE' },                  // Gartenpflege
          { type: 'Gas Emergency/Gas Odor', headerKey: 'GAS_EMERGENCY_GAS_ODOR' },          // Gas-Notdienst/Gasgeruch
          { type: 'Gas Supply/Emergency Service', headerKey: 'GAS_SUPPLY_EMERGENCY_SERVICE' }, // Gasversorgung/Störungsdienst
          { type: 'Building Insurance', headerKey: 'BUILDING_INSURANCE' },                 // Gebäudeversicherung
          { type: 'Fiber / Internet', headerKey: 'FIBER_INTERNET' },                        // Glasfaser / Internet
          { type: 'Green Roof Maintenance', headerKey: 'GREEN_ROOF_MAINTENANCE' },          // Gründachpflege
          { type: 'Green Pruning', headerKey: 'GREEN_PRUNING' },                             // Grünschnitt
          { type: 'Lifting Systems and Pumps', headerKey: 'LIFTING_SYSTEMS_AND_PUMPS' },    // Hebeanlagen und Pumpen
          { type: 'Heating', headerKey: 'HEATING' },                                        // Heizung
          { type: 'Heating Cost Allocator', headerKey: 'HEATING_COST_ALLOCATOR' },          // Heizkostenabrechner
          { type: 'Heating Oil Supply', headerKey: 'HEATING_OIL_SUPPLY' },                  // Heizölversorgung
          { type: 'Cable Television', headerKey: 'CABLE_TELEVISION' },                      // Kabelfernsehen
          { type: 'Sewer/Blockage', headerKey: 'SEWER_BLOCKAGE' },                          // Kanal-/verstopfung
          { type: 'Ventilation', headerKey: 'VENTILATION' },                                // Lüftung
          { type: 'Rental Mat Service', headerKey: 'RENTAL_MAT_SERVICE' },                  // Mietmattenservice
          { type: 'Local Heating Supplier', headerKey: 'LOCAL_HEATING_SUPPLIER' },          // Nahwärmeversorger
          { type: 'Electric Storage Heater', headerKey: 'ELECTRIC_STORAGE_HEATER' },        // Nachtspeicherofen
          { type: 'Police', headerKey: 'POLICE' },        // Polizei
          { type: 'Smoke and Heat Extraction System', headerKey: 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM' }, // Rauch- und Wärmeabzugsanlage
          { type: 'Pipe Blockage', headerKey: 'PIPE_BLOCKAGE' },                            // Rohrverstopfung
          { type: 'Pipe Burst & Water Damage', headerKey: 'PIPE_BURST_WATER_DAMAGE' },      // Rohrbruch & Wasserschaden
          { type: 'Smoke Detector', headerKey: 'SMOKE_DETECTOR' },                          // Rauchwarnmelder
          { type: 'Roller Shutter/Raffstore', headerKey: 'ROLLER_SHUTTER_RAFFSTORE' },      // Rollo/Raffstore
          { type: 'Sanitary', headerKey: 'SANITARY' },                                      // Sanitär
          { type: 'Pest Control', headerKey: 'PEST_CONTROL' },                              // Schädlingsbekämpfung
          { type: 'Locksmith Service', headerKey: 'LOCKSMITH_SERVICE' },                    // Schlüsseldienst
          { type: 'Locking System Maintenance', headerKey: 'LOCKING_SYSTEM_MAINTENANCE' },  // Schließanlage
          { type: 'Chimney Sweep', headerKey: 'CHIMNEY_SWEEP' },                            // Schornsteinfeger
          { type: 'Solar System/PVA', headerKey: 'SOLAR_SYSTEM_PVA' },                      // Solaranlage/PVA
          { type: 'Bulk Waste Collection', headerKey: 'BULK_WASTE_COLLECTION' },            // Sperrmüllabholung
          { type: 'Power Supply/Emergency Service', headerKey: 'POWER_SUPPLY_EMERGENCY_SERVICE' }, // Stromversorger/Störungsdienst
          { type: 'Gate/Gate Systems', headerKey: 'GATE_GATE_SYSTEMS' },                    // Tore/Toranlagen
          { type: 'Street and Sidewalk Cleaning', headerKey: 'STREET_AND_SIDEWALK_CLEANING' }, // Straßen- und Gehwegreinigung
          { type: 'Stairwell Cleaning', headerKey: 'STAIRWELL_CLEANING' },                  // Treppenhausreinigung
          { type: 'Water Supply', headerKey: 'WATER_SUPPLY' },                              // Wasserversorgung
          { type: 'Doors', headerKey: 'DOORS' },                                             // Türen
          { type: 'Roofer', headerKey: 'ROOFER' },                                           // Dachdecker
          { type: 'WE Meter', headerKey: 'WE_METER' },                                       // WE-Zähler
          { type: 'Recyclable Waste Disposal', headerKey: 'RECYCLABLE_WASTE_DISPOSAL' },    // Wertstoffentsorgung
          { type: 'Winter Service', headerKey: 'WINTER_SERVICE' },                          // Winterdienst
          { type: 'Apartment Transfer Station (DHW/Heating)', headerKey: 'APARTMENT_TRANSFER_STATION_DHW_HEATING' }, // Wohnungsübergabestation (WW/ Hzg)
        ];

        // Filter and populate serviceOptions based on available headers
        this.serviceOptions = knownServices
          .filter((service) => this.headers.includes(service.headerKey))
          .map((service) => ({
            label: this.translate.instant(`TECHNICAL_SERVICES.${service.headerKey}`),
            value: service.type,
          }));

        // Determine visibility of email and phone fields based on headers
        this.adjustFieldsBasedOnHeaders();
      },
      (error) => {
        this.message.error(this.translate.instant('CONTACTS.HEADERS_FETCH_FAILED'));
      }
    );
  }

  adjustFieldsBasedOnHeaders() {
    const roleMappings = [
      {
        role: 'Property Manager',
        emailHeader: 'PROPERTY_MANAGER_EMAIL',
        phoneHeader: 'PROPERTY_MANAGER_PHONE',
      },
      {
        role: 'Technical Assets Manager',
        emailHeader: 'TECHNICAL_ASSETS_MANAGER_EMAIL',
        phoneHeader: 'TECHNICAL_ASSETS_MANAGER_PHONE',
      },
      {
        role: 'Condominium Manager',
        emailHeader: 'CONDOMINIUM_MANAGER_EMAIL',
        phoneHeader: 'CONDOMINIUM_MANAGER_PHONE',
      },
      {
        role: 'Accountant',
        emailHeader: 'ACCOUNTANT_EMAIL',
        phoneHeader: 'ACCOUNTANT_PHONE',
      },
    ];

    this.showEmailFieldTable = roleMappings.some((mapping) =>
      this.headers.includes(mapping.emailHeader)
    );
    this.showPhoneFieldTable = roleMappings.some((mapping) =>
      this.headers.includes(mapping.phoneHeader)
    );
  }

  loadEmployees() {
    this.isLoadingEmployees = true;
    this.contactService.getEmployees().subscribe((employees) => {
        this.originalEmployees = [...employees];
        this.allEmployees = [...employees];

        if (this.employeeSearchTerm?.trim()) {
          // keep the filtered view after reload
          this.filterEmployees();
        } else {
          this.employeesPagination.total = this.allEmployees.length;
          this.applyEmployeeSorting();
          this.applyEmployeePagination();
        }

        this.isLoadingEmployees = false;
      },
      (error) => {
        this.message.error(this.translate.instant('ERROR_MESSAGES.FETCH_FAILED'));
        this.isLoadingEmployees = false;
      });
  }

  loadCaretakers() {
    this.isLoadingCaretakers = true;
    this.contactService.getCaretakers().subscribe((caretakers) => {
        this.originalCaretakers = [...caretakers];
        this.allCaretakers = [...caretakers];

        if (this.caretakerSearchTerm?.trim()) {
          this.filterCaretakers();
        } else {
          this.caretakersPagination.total = this.allCaretakers.length;
          this.applyCaretakerSorting();
          this.applyCaretakerPagination();
        }

        this.isLoadingCaretakers = false;
      },
      (error) => {
        this.message.error(this.translate.instant('ERROR_MESSAGES.FETCH_FAILED'));
        this.isLoadingCaretakers = false;
      });
  }

  loadServices() {
    this.isLoadingServices = true;
    this.contactService.getServices().subscribe((services) => {
        const normalizedServices = (services || []).map((service) => normalizeServiceContact(service));
        this.originalServices = [...normalizedServices];
        this.allServices = [...normalizedServices];

        if (this.serviceSearchTerm?.trim()) {
          this.filterServices();
        } else {
          this.servicesPagination.total = this.allServices.length;
          this.applyServiceSorting();
          this.applyServicePagination();
        }

        this.isLoadingServices = false;
      },
      (error) => {
        this.message.error(this.translate.instant('ERROR_MESSAGES.FETCH_FAILED'));
        this.isLoadingServices = false;
      });
  }

  deleteService(service: any): void {
    if (!service?._id) {
      return;
    }

    this.deletingServiceId = service._id;
    this.contactService.deleteService(service._id).subscribe({
      next: () => {
        this.message.success(this.translate.instant('CONTACTS.SERVICE_DELETE_SUCCESS'));
        this.removeServiceFromLists(service._id);
        this.deletingServiceId = null;
      },
      error: (error) => {
        if (shouldSuppressGenericError(error)) {
          this.deletingServiceId = null;
          return;
        }
        if (error?.message === 'SERVICE_ASSIGNED_TO_PROPERTIES') {
          this.message.info(this.translate.instant('CONTACTS.SERVICE_DELETE_ASSIGNED'));
        } else {
          this.message.error(this.translate.instant('CONTACTS.SERVICE_DELETE_FAILED'));
        }
        this.deletingServiceId = null;
      }
    });
  }

  private removeServiceFromLists(serviceId: string): void {
    this.originalServices = this.originalServices.filter(service => service._id !== serviceId);
    this.allServices = this.allServices.filter(service => service._id !== serviceId);
    this.servicesPagination.total = this.allServices.length;

    if (this.serviceSearchTerm?.trim()) {
      this.filterServices();
    } else {
      this.applyServiceSorting();
      this.applyServicePagination();
    }
  }

  deleteEmployee(employee: any): void {
    if (!employee?._id) {
      return;
    }

    this.deletingEmployeeId = employee._id;

    this.contactService.deleteEmployee(employee._id).subscribe({
      next: () => {
        this.message.success(this.translate.instant('CONTACTS.EMPLOYEE_DELETE_SUCCESS'));
        this.removeEmployeeFromLists(employee._id);
        this.deletingEmployeeId = null;
      },
      error: (error) => {
        if (shouldSuppressGenericError(error)) {
          this.deletingEmployeeId = null;
          return;
        }
        if (error?.message === 'EMPLOYEE_ASSIGNED_TO_PROPERTIES') {
          this.message.info(this.translate.instant('CONTACTS.EMPLOYEE_DELETE_ASSIGNED'));
        } else {
          this.message.error(this.translate.instant('CONTACTS.EMPLOYEE_DELETE_FAILED'));
        }
        this.deletingEmployeeId = null;
      },
    });
  }

  private removeEmployeeFromLists(employeeId: string): void {
    this.originalEmployees = this.originalEmployees.filter(e => e._id !== employeeId);
    this.allEmployees = this.allEmployees.filter(e => e._id !== employeeId);
    this.employeesPagination.total = this.allEmployees.length;

    if (this.employeeSearchTerm?.trim()) {
      this.filterEmployees();
    } else {
      this.applyEmployeeSorting();
      this.applyEmployeePagination();
    }
  }

  deleteCaretaker(caretaker: any): void {
    if (!caretaker?._id) {
      return;
    }

    this.deletingCaretakerId = caretaker._id;

    this.contactService.deleteCaretaker(caretaker._id).subscribe({
      next: () => {
        this.message.success(this.translate.instant('CONTACTS.CARETAKER_DELETE_SUCCESS'));
        this.removeCaretakerFromLists(caretaker._id);
        this.deletingCaretakerId = null;
      },
      error: (error) => {
        if (shouldSuppressGenericError(error)) {
          this.deletingCaretakerId = null;
          return;
        }
        if (error?.message === 'CARETAKER_ASSIGNED_TO_PROPERTIES') {
          this.message.info(this.translate.instant('CONTACTS.CARETAKER_DELETE_ASSIGNED'));
        } else {
          this.message.error(this.translate.instant('CONTACTS.CARETAKER_DELETE_FAILED'));
        }
        this.deletingCaretakerId = null;
      },
    });
  }

  private removeCaretakerFromLists(caretakerId: string): void {
    this.originalCaretakers = this.originalCaretakers.filter(c => c._id !== caretakerId);
    this.allCaretakers = this.allCaretakers.filter(c => c._id !== caretakerId);
    this.caretakersPagination.total = this.allCaretakers.length;

    if (this.caretakerSearchTerm?.trim()) {
      this.filterCaretakers();
    } else {
      this.applyCaretakerSorting();
      this.applyCaretakerPagination();
    }
  }

  applyEmployeePagination(): void {
    const start = (this.employeesPagination.pageIndex - 1) * this.employeesPagination.pageSize;
    const end = this.employeesPagination.pageIndex * this.employeesPagination.pageSize;
    this.employees = this.allEmployees.slice(start, end);
  }

  // Apply Pagination for Caretakers
  applyCaretakerPagination(): void {
    const start = (this.caretakersPagination.pageIndex - 1) * this.caretakersPagination.pageSize;
    const end = this.caretakersPagination.pageIndex * this.caretakersPagination.pageSize;
    this.caretakers = this.allCaretakers.slice(start, end);
  }

  // Apply Pagination for Services
  applyServicePagination(): void {
    const start = (this.servicesPagination.pageIndex - 1) * this.servicesPagination.pageSize;
    const end = this.servicesPagination.pageIndex * this.servicesPagination.pageSize;
    this.services = this.allServices.slice(start, end);
  }

  openAddModal(type: string): void {
    this.openUpsertModal(type, null);
  }

  openEditModal(contact: any, type: string): void {
    this.openUpsertModal(type, contact);
  }

  private async openUpsertModal(type: string, contact: any | null): Promise<void> {
    const modalType = (type === 'employee' || type === 'caretaker' || type === 'service')
      ? type
      : 'employee';
    const result = await firstValueFrom(
      this.contactUpsertModal.open({
        type: modalType,
        contact: contact || undefined,
        origin: 'contact-list',
      })
    );

    if (!result?.entity) {
      return;
    }

    if (modalType === 'service') {
      this.loadServices();
      return;
    }

    this.loadEmployees();
    this.loadCaretakers();
    this.progressService.notifyProgressUpdated();
  }

  // Handle Pagination Changes for Employees
  onEmployeesPageIndexChange(pageIndex: number): void {
    this.employeesPagination.pageIndex = pageIndex;
    this.applyEmployeePagination();
  }

  onEmployeesPageSizeChange(pageSize: number): void {
    this.employeesPagination.pageSize = pageSize;
    this.employeesPagination.pageIndex = 1; // Reset to first page
    this.applyEmployeePagination();
  }

  onEmployeesSortChange(key: string, value: any): void {
    this.employeesSort = { key, value };
    this.applyEmployeeSorting();
    this.applyEmployeePagination();  // Adjust pagination after sorting
  }

  applyEmployeeSorting(): void {
    if (this.employeesSort.key && this.employeesSort.value) {
      const sortOrder = this.employeesSort.value === 'ascend' ? 1 : -1;
      this.allEmployees.sort((a, b) => {
        const aVal = a[this.employeesSort.key]?.toString().toLowerCase() || '';
        const bVal = b[this.employeesSort.key]?.toString().toLowerCase() || '';
        return aVal < bVal ? -1 * sortOrder : aVal > bVal ? 1 * sortOrder : 0;
      });
    }
  }

  onCaretakersPageIndexChange(pageIndex: number): void {
    this.caretakersPagination.pageIndex = pageIndex;
    this.applyCaretakerPagination();
  }

  onCaretakersPageSizeChange(pageSize: number): void {
    this.caretakersPagination.pageSize = pageSize;
    this.caretakersPagination.pageIndex = 1; // Reset to first page
    this.applyCaretakerPagination();
  }

// Handle Sorting for Caretakers
  onCaretakersSortChange(key: string, value: any): void {
    this.caretakersSort = { key, value };
    this.applyCaretakerSorting();
    this.applyCaretakerPagination();  // Adjust pagination after sorting
  }

  applyCaretakerSorting(): void {
    if (this.caretakersSort.key && this.caretakersSort.value) {
      const sortOrder = this.caretakersSort.value === 'ascend' ? 1 : -1;
      this.allCaretakers.sort((a, b) => {
        const aVal = this.caretakersSort.key === 'contactPerson'
          ? this.getPrimaryCaretakerContactName(a)
          : (a[this.caretakersSort.key]?.toString().toLowerCase() || '');
        const bVal = this.caretakersSort.key === 'contactPerson'
          ? this.getPrimaryCaretakerContactName(b)
          : (b[this.caretakersSort.key]?.toString().toLowerCase() || '');
        if (aVal === bVal && this.caretakersSort.key === 'contactPerson') {
          const aProvider = String(a.name || '').toLowerCase();
          const bProvider = String(b.name || '').toLowerCase();
          return aProvider < bProvider ? -1 * sortOrder : aProvider > bProvider ? 1 * sortOrder : 0;
        }
        return aVal < bVal ? -1 * sortOrder : aVal > bVal ? 1 * sortOrder : 0;
      });
    }
  }

  onServicesPageSizeChange(pageSize: number): void {
    this.servicesPagination.pageSize = pageSize;
    this.servicesPagination.pageIndex = 1; // Reset to first page
    this.applyServicePagination();
  }

  onServicesPageIndexChange(pageIndex: number): void {
    this.servicesPagination.pageIndex = pageIndex;
    this.applyServicePagination();
  }

// Handle Sorting for Services
  onServicesSortChange(key: string, value: any): void {
    this.servicesSort = { key, value };
    this.applyServiceSorting();
    this.applyServicePagination();  // Adjust pagination after sorting
  }

  applyServiceSorting(): void {
    if (this.servicesSort.key && this.servicesSort.value) {
      const sortOrder = this.servicesSort.value === 'ascend' ? 1 : -1;

      this.allServices.sort((a, b) => {
        let aVal = '';
        let bVal = '';

        if (this.servicesSort.key === 'serviceType') {
          // Sort by the displayed (translated) value users see in the table
          aVal = this.getTranslatedServiceTypes(a) || '';
          bVal = this.getTranslatedServiceTypes(b) || '';
        } else {
          aVal = (a[this.servicesSort.key] ?? '').toString();
          bVal = (b[this.servicesSort.key] ?? '').toString();
        }

        // Locale-aware compare for German labels (handles ä/ö/ü properly)
        const cmp = aVal.localeCompare(bVal, 'de', { sensitivity: 'base' });
        return cmp * sortOrder;
      });
    }
  }

  formatGermanPhoneNumber(phone?: string, defaultNdc?: string): string {
    if (!phone) return '';
    return this.dePhone.normalize(phone, { defaultNdc }).display;
  }

  getTranslatedServiceType(serviceType: string): string {
    if (!serviceType) {
      return '';
    }
    const translationKey = serviceTypeTranslationKeys[serviceType];
    if (translationKey) {
      return this.translate.instant('TECHNICAL_SERVICES.' + translationKey);
    } else {
      // Handle cases where the service type is not in the mapping
      return serviceType; // Or return a default value or message
    }
  }

  getTranslatedServiceTypes(service: any): string {
    return getServiceTypes(service)
      .map((serviceType) => this.getTranslatedServiceType(serviceType))
      .filter((value) => !!value)
      .join(', ');
  }

  getTranslatedRole(role: string): string {
    if (role === 'Property Manager') {
      return this.translate.instant('PROPERTY_LIST.PROPERTY_MANAGER');
    } else if (role === 'Technical Assets Manager') {
      return this.translate.instant('PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER');
    } else if (role === 'Condominium Manager') {
      return this.translate.instant('PROPERTY_LIST.CONDOMINIUM_MANAGER');
    } else if (role === 'Accountant') {
      return this.translate.instant('PROPERTY_LIST.ACCOUNTANT');
    }
    return role; // Default to role name if no translation is found
  }

  filterEmployees(): void {
    const term = this.employeeSearchTerm;
    this.allEmployees = this.originalEmployees.filter(emp =>
      matchesTextSearch(emp.name, term) ||
      (this.showEmailFieldTable && matchesTextSearch(emp.email, term)) ||
      (this.showPhoneFieldTable && matchesPhoneSearch(emp.phone, term)) ||
      (this.showPhoneFieldTable && matchesPhoneSearch(emp.mobile, term)) ||
      matchesTextSearch(emp.role, term)
    );
    this.employeesPagination.total = this.allEmployees.length;
    this.applyEmployeeSorting();
    this.applyEmployeePagination();
  }

  filterCaretakers(): void {
    const term = this.caretakerSearchTerm;
    this.allCaretakers = this.originalCaretakers.filter(ct =>
      matchesTextSearch(ct.name, term) ||
      matchesTextSearch(this.getCaretakerContactSummary(ct), term) ||
      matchesTextSearch(ct.email, term) ||
      matchesPhoneSearch(ct.phone, term) ||
      matchesPhoneSearch(ct.mobile, term) ||
      matchesPhoneSearch(ct.emergencyNumber, term) ||
      matchesTextSearch(ct.address, term)
    );
    this.caretakersPagination.total = this.allCaretakers.length;
    this.applyCaretakerSorting();
    this.applyCaretakerPagination();
  }

  getCaretakerContactPersons(caretaker: any): any[] {
    const source = Array.isArray(caretaker?.contactPersons)
      ? caretaker.contactPersons
      : (typeof caretaker?.contactPerson === 'string' && caretaker.contactPerson.trim()
        ? [{ name: caretaker.contactPerson.trim(), isPrimary: true }]
        : []);
    const seen = new Set<string>();
    return source
      .filter((person: any) => {
        const name = String(person?.name || '').trim();
        const id = String(person?._id || '').trim();
        if (!name || (id && seen.has(id))) return false;
        if (id) seen.add(id);
        return true;
      })
      .sort((left: any, right: any) => Number(right?.isPrimary === true) - Number(left?.isPrimary === true));
  }

  getPrimaryCaretakerContactName(caretaker: any): string {
    return String(this.getCaretakerContactPersons(caretaker)[0]?.name || '').toLowerCase();
  }

  getCaretakerContactSummary(caretaker: any): string {
    return this.getCaretakerContactPersons(caretaker)
      .map((person: any) => person.position ? `${person.name} (${person.position})` : person.name)
      .join(', ');
  }

  filterServices(): void {
    const term = this.serviceSearchTerm;
    this.allServices = this.originalServices.filter(s =>
      matchesTextSearch(s.serviceName, term) ||
      matchesPhoneSearch(s.phone, term) ||
      matchesPhoneSearch(s.mobile, term) ||
      matchesPhoneSearch(s.emergencyNumber, term) ||
      matchesTextSearch(s.email, term) ||
      getServiceTypes(s).some((serviceType) => matchesTextSearch(serviceType, term)) ||
      matchesTextSearch(this.getTranslatedServiceTypes(s), term)
    );
    this.servicesPagination.total = this.allServices.length;
    this.applyServiceSorting();
    this.applyServicePagination();
  }
  // Totals for headings (reflect current filtered list, not just current page)
  get employeesTotalCount(): number {
    return this.employeesPagination.total ?? 0;
  }

  get caretakersTotalCount(): number {
    return this.caretakersPagination.total ?? 0;
  }

  get servicesTotalCount(): number {
    return this.servicesPagination.total ?? 0;
  }
}
